export default __webpack_public_path__ + "static/magenta-bg-0313d45fd023bee32ccc729a621e5433.jpg";